import { IconButton } from '@/app/components/buttons/IconButton';
import {
  customHeaderClass,
  datePickerMonthClass,
} from '@/app/components/form/DateInput/components/CustomHeader/styles';
import type { SingleCustomHeaderProps } from '../types';
import ChevronLeftIcon from '/public/icons/calendar-chevron-left.svg';
import ChevronRightIcon from '/public/icons/calendar-chevron-right.svg';
import ClearIcon from '/public/icons/cross.svg';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const getYears = (start: number, end: number) => {
  const years: number[] = [];
  for (let y = start; y <= end; y++) years.push(y);
  return years;
};

export const SinglePickerCustomHeader = ({
  monthDate,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  disabled,
  onClear,
  hasValue,
  changeYear,
  changeMonth,
}: SingleCustomHeaderProps & {
  changeYear?: (year: number) => void;
  changeMonth?: (month: number) => void;
}) => {
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;
  const maxYear = currentYear + 20;

  const handleMonthSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (changeMonth) {
      changeMonth(Number(e.target.value));
    }
  };

  const handleYearSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (changeYear) {
      changeYear(Number(e.target.value));
    }
  };

  const selectedMonthIdx = monthDate.getMonth();
  const selectedYear = monthDate.getFullYear();

  return (
    <div className={customHeaderClass()}>
      <IconButton
        aria-label="Previous Month"
        type="button"
        onClick={decreaseMonth}
        disabled={disabled || prevMonthButtonDisabled}
        icon={<ChevronLeftIcon />}
      />
      <div
        className={datePickerMonthClass() + ' cursor-pointer relative flex gap-2 items-center justify-center'}
        tabIndex={0}
        aria-label="Select month and year"
        style={{ userSelect: 'none' }}
      >
        <div className="bg-white flex gap-2">
          <select
            className="outline-none bg-transparent cursor-pointer"
            value={selectedMonthIdx}
            onChange={handleMonthSelect}
            disabled={disabled}
            aria-label="Select month"
          >
            {MONTHS.map((m, idx) => (
              <option value={idx} key={m}>
                {m}
              </option>
            ))}
          </select>
          <select
            className="outline-none bg-transparent cursor-pointer"
            value={selectedYear}
            onChange={handleYearSelect}
            disabled={disabled}
            aria-label="Select year"
          >
            {getYears(minYear, maxYear).map((y) => (
              <option value={y} key={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex items-center gap-1.5">
        {onClear && hasValue && (
          <IconButton
            aria-label="Clear date"
            type="button"
            onClick={onClear}
            icon={<ClearIcon className="w-[12px] h-[12px] fill-current" />}
          />
        )}
        <IconButton
          aria-label="Next Month"
          type="button"
          onClick={increaseMonth}
          disabled={disabled || nextMonthButtonDisabled}
          icon={<ChevronRightIcon />}
        />
      </div>
    </div>
  );
};
